import React, { useState, useEffect } from 'react';
import { ChevronLeftIcon, ChevronRightIcon, PlayIcon } from '@heroicons/react/24/outline';

const FactoryShowcase = () => {
  const [currentImage, setCurrentImage] = useState(0);
  const [isPlaying, setIsPlaying] = useState(true);

  const factoryImages = [
    {
      id: 1,
      title: '4 экструзионные линии',
      description: 'Современное оборудование от ведущих мировых производителей',
      image: '/factory-slider-images/photo_1_2025-08-07_23-54-27.jpg',
      stats: { capacity: '6000 тонн/год', lines: '4 линии' }
    },
    {
      id: 2,
      title: 'Инженерно-технический состав',
      description: 'Высококвалифицированные специалисты с многолетним опытом',
      image: '/factory-slider-images/photo_2_2025-08-07_23-54-27.jpg',
      stats: { experience: 'Многолетний опыт', qualification: 'Высокая квалификация' }
    },
    {
      id: 3,
      title: 'Диаметр от 20 до 1200 мм',
      description: 'Полный спектр размеров для любых задач',
      image: '/factory-slider-images/photo_3_2025-08-07_23-54-27.jpg',
      stats: { minDiameter: '20 мм', maxDiameter: '1200 мм' }
    },
    {
      id: 4,
      title: 'Системы менеджмента',
      description: 'Сертифицированные системы качества, экологии и безопасности',
      image: '/factory-slider-images/photo_4_2025-08-07_23-54-27.jpg',
      stats: { quality: 'ISO 9001', ecology: 'ISO 14001' }
    },
    {
      id: 5,
      title: 'Производственные цеха',
      description: 'Современные производственные помещения с климат-контролем',
      image: '/factory-slider-images/photo_5_2025-08-07_23-54-27.jpg',
      stats: { area: '5000 м²', climate: 'Климат-контроль' }
    },
    {
      id: 6,
      title: 'Складские помещения',
      description: 'Большие складские площади для хранения готовой продукции',
      image: '/factory-slider-images/photo_6_2025-08-07_23-54-27.jpg',
      stats: { storage: '10000 м²', capacity: '2000 тонн' }
    },
    {
      id: 7,
      title: 'Лаборатория качества',
      description: 'Современная лаборатория для контроля качества продукции',
      image: '/factory-slider-images/photo_7_2025-08-07_23-54-27.jpg',
      stats: { tests: '24/7 контроль', equipment: 'Современное оборудование' }
    },
    {
      id: 8,
      title: 'Линия экструзии',
      description: 'Высокотехнологичное экструзионное оборудование',
      image: '/factory-slider-images/photo_8_2025-08-07_23-54-40.jpg',
      stats: { speed: 'До 20 м/мин', precision: 'Точность ±0.1 мм' }
    },
    {
      id: 9,
      title: 'Намоточные устройства',
      description: 'Автоматизированные системы намотки готовой продукции',
      image: '/factory-slider-images/photo_9_2025-08-07_23-54-27.jpg',
      stats: { automation: 'Полная автоматизация', capacity: 'До 1000 м' }
    },
    {
      id: 10,
      title: 'Производственный процесс',
      description: 'Непрерывный цикл производства с контролем на каждом этапе',
      image: '/factory-slider-images/photo_10_2025-08-07_23-54-27.jpg',
      stats: { cycle: '24/7', control: 'Полный контроль' }
    },
    {
      id: 11,
      title: 'Готовая продукция',
      description: 'Широкий ассортимент труб различных диаметров',
      image: '/factory-slider-images/photo_11_2025-08-07_23-54-40.jpg',
      stats: { range: '20-1200 мм', types: '50+ видов' }
    },
    {
      id: 12,
      title: 'Упаковка и маркировка',
      description: 'Профессиональная упаковка для безопасной транспортировки',
      image: '/factory-slider-images/photo_12_2025-08-07_23-54-40.jpg',
      stats: { marking: 'Лазерная маркировка', protection: 'Защитная упаковка' }
    },
    {
      id: 13,
      title: 'Отгрузка продукции',
      description: 'Организованная система логистики и доставки',
      image: '/factory-slider-images/photo_13_2025-08-07_23-54-40.jpg',
      stats: { delivery: 'По всему Казахстану', fleet: 'Собственный автопарк' }
    },
    {
      id: 14,
      title: 'Технический контроль',
      description: 'Многоступенчатая система контроля качества',
      image: '/factory-slider-images/photo_14_2025-08-07_23-54-40.jpg',
      stats: { stages: '5 этапов контроля', standards: 'ГОСТ, ISO' }
    },
    {
      id: 15,
      title: 'Сырьевая база',
      description: 'Высококачественное сырье от проверенных поставщиков',
      image: '/factory-slider-images/photo_15_2025-08-07_23-54-40.jpg',
      stats: { quality: 'Премиум качество', suppliers: 'Мировые бренды' }
    }
  ];

  useEffect(() => {
    if (!isPlaying) return;
    
    const timer = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % factoryImages.length);
    }, 4000);
    
    return () => clearInterval(timer);
  }, [isPlaying, factoryImages.length]);

  const nextImage = () => {
    setCurrentImage((prev) => (prev + 1) % factoryImages.length);
  };

  const prevImage = () => {
    setCurrentImage((prev) => (prev - 1 + factoryImages.length) % factoryImages.length);
  };

  const togglePlayback = () => {
    setIsPlaying(!isPlaying);
  };

  return (
    <section className="py-20 bg-secondary-900 text-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-primary-600/20 text-primary-300 text-sm font-medium mb-4">
            🏭 Наше производство
          </div>
          <h2 className="text-3xl lg:text-4xl font-bold mb-6">
            Современные <span className="text-primary-400">производственные мощности</span>
          </h2>
          <p className="text-xl text-secondary-300 max-w-3xl mx-auto">
            Экскурсия по нашему заводу - от производства до отгрузки готовой продукции
          </p>
        </div>

        {/* Main Showcase */}
        <div className="relative">
          {/* Image Container */}
          <div className="relative h-96 lg:h-[600px] rounded-3xl overflow-hidden shadow-2xl">
            <div className="relative w-full h-full">
              <img 
                src={factoryImages[currentImage].image}
                alt={factoryImages[currentImage].title}
                className="w-full h-full object-cover transition-all duration-1000 ease-in-out"
              />
              
              {/* Dark Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
              
              {/* Content Overlay */}
              <div className="absolute bottom-0 left-0 right-0 p-8 lg:p-12">
                <div className="max-w-2xl">
                  <h3 className="text-2xl lg:text-4xl font-bold mb-4 text-white">
                    {factoryImages[currentImage].title}
                  </h3>
                  <p className="text-lg lg:text-xl text-gray-200 mb-6">
                    {factoryImages[currentImage].description}
                  </p>
                  
                  {/* Stats */}
                  <div className="flex flex-wrap gap-6">
                    {Object.entries(factoryImages[currentImage].stats).map(([key, value]) => (
                      <div key={key} className="bg-white/10 backdrop-blur-sm rounded-xl px-4 py-2">
                        <span className="text-primary-300 text-sm font-medium block">{value}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Navigation Arrows */}
            <button 
              onClick={prevImage}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white/20 transition-all duration-200 text-white"
            >
              <ChevronLeftIcon className="h-6 w-6" />
            </button>
            
            <button 
              onClick={nextImage}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white/20 transition-all duration-200 text-white"
            >
              <ChevronRightIcon className="h-6 w-6" />
            </button>

            {/* Play/Pause Button */}
            <button 
              onClick={togglePlayback}
              className="absolute top-4 right-4 w-12 h-12 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white/20 transition-all duration-200 text-white"
            >
              <PlayIcon className={`h-5 w-5 ${isPlaying ? 'opacity-50' : 'opacity-100'}`} />
            </button>
          </div>

          {/* Thumbnails with horizontal scroll */}
          <div className="relative mt-8">
            <div className="flex justify-start overflow-x-auto scrollbar-hide space-x-4 pb-2 px-4">
              {factoryImages.map((image, index) => (
                <button
                  key={image.id}
                  onClick={() => setCurrentImage(index)}
                  className={`relative flex-shrink-0 w-20 h-16 lg:w-24 lg:h-20 rounded-xl overflow-hidden transition-all duration-300 ${
                    currentImage === index 
                      ? 'ring-4 ring-primary-400 scale-110' 
                      : 'hover:scale-105 opacity-60 hover:opacity-100'
                  }`}
                >
                  <img 
                    src={image.image} 
                    alt={image.title}
                    className="w-full h-full object-cover"
                  />
                  {currentImage === index && (
                    <div className="absolute inset-0 bg-primary-400/20"></div>
                  )}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Factory Stats */}
        <div className="mt-20 grid grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="text-center">
            <div className="text-3xl lg:text-4xl font-bold text-primary-400 mb-2">2010</div>
            <div className="text-secondary-300">Год основания</div>
          </div>
          <div className="text-center">
            <div className="text-3xl lg:text-4xl font-bold text-primary-400 mb-2">6000</div>
            <div className="text-secondary-300">тонн в год</div>
          </div>
          <div className="text-center">
            <div className="text-3xl lg:text-4xl font-bold text-primary-400 mb-2">4</div>
            <div className="text-secondary-300">экструзионные линии</div>
          </div>
          <div className="text-center">
            <div className="text-3xl lg:text-4xl font-bold text-primary-400 mb-2">1200</div>
            <div className="text-secondary-300">макс. диаметр мм</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FactoryShowcase;